import makeStyles from '@mui/styles/makeStyles';
import config from '../../../../app/config';

export const useIceStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '99%',
        marginTop: 6,
    },
    modalBackground: {
        backgroundColor: theme.palette.mode === 'light' ? '#ffffff' : '#313233',
    },
    search: {
        overflow: 'hidden',
        backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#222525',
        backgroundImage: 'none',
        boxShadow: 'none',
        //   padding: 10,
    },
    table: {
        marginTop: 5,
        borderCollapse: 'separate',
        borderSpacing: '0px 4px',
        paddingRight: 5,
    },
    headCell: {
        fontSize: 14,
        background: theme.palette.background.paper,
        '&.left': {
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
        },
        '&.right': {
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
        },
    },
    rowCell: {
        fontSize: 'small',
        backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#313233',
        '&.left': {
            borderTopLeftRadius: 4,
            borderBottomLeftRadius: 4,
            padding: 0,
            paddingLeft: 5,
        },
        '&.right': {
            borderTopRightRadius: 4,
            borderBottomRightRadius: 4,
        },
    },
    tableRow: {
        cursor: 'pointer',
        '&:hover': {
            background: theme.palette.mode === 'light' ? '#414141' : '#b1abab',
        },
    },
    iframe: {
        width: '100%',
        height: config?.actionButtonsOnBottomBar ? '99%' : '95%',
    },
    toolbar: {
        fontSize: 'small',
    },
    loading: {
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: 'x-large',
    },
    label: {
        color: theme.palette.mode === 'light' ? '#626466' : '#ACAFB3',
        fontWeight: 'bold',
        fontSize: 14,
        marginLeft: 2,
    },
    selectField: {
        borderRadius: 4,
        border: `1px solid ${theme.palette.mode === 'light' ? '#BFC2C7' : '#626466'}`,
        backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#313233',
        height: 35,
        '&::placeholder': {
            fontStyle: 'italic',
        },
    },
    actionButtons: {
        marginTop: 15,
        marginBottom: 5,
        marginLeft: 'auto',
        float: 'right',
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        gap: 10,
    },
    actionBtn: {
        backgroundColor: theme.palette.mode === 'light' ? '#FFFFFF' : '#494B4C',
        borderRadius: 6,
    },
    divider: {
        margin: '10px 0',
    },
    actions: {
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        '& .MuiTableCell-head': {
            backgroundColor: theme.palette.mode === 'light' ? '#eff1f3' : '#494B4C',
        },
    },
    colorStudies: {
        height: 35,
        width: 10,
        marginLeft: 5,
    },
    abnormal: {
        backgroundColor: '#85200c',
        color: '#fff',
        borderRadius: 8,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 25,
        height: 25,
        marginLeft: 5,
    },
    range: {
        float: 'right',
        paddingRight: 20,
        fontStyle: 'italic',
    },
    invInfo: {
        backgroundColor: theme.palette.background.field,
        borderRadius: 6,
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        alignItems: 'center',
        padding: '4px 8px',
        marginBottom: 8,
    },
    invInfoText: {
        fontWeight: 'bold',
        display: 'flex',
    },
    groupBar: {
        borderRadius: 8,
        width: '100%',
        height: 5,
        margin: '2px 0',
    },
}));